import LoginPanel from "./components/LoginPanel";
import Cookies from 'js-cookie'

import React from 'react'
import { LoginToasts } from './js/login-toast'
import { LoginContext, LoginProvider } from "./contexts/LoginContext";

import { axiosGet, axiosPost, baseURL } from '../common/js/axios-utility'

import { type LoginData } from "../common/js/bfx-customer-utility";
import { completeHubLogin } from "../common/js/bfx-hub-utility";
import { errorToast } from '../common/js/toast-utility'
import { useTranslation } from 'react-i18next'

export default function App({toastContainerId}: {toastContainerId: string}) {
    const {t} = useTranslation(['account']);

    const onLoginComplete = (data: LoginData) => {
        const params = new URLSearchParams(window.location.search);
        const sso = params.get('sso');
        const sig = params.get('sig');
        const source = params.get('source');
        if (sso && sig) {
            discourseLogin(sso, sig, data);
        }
        else if (source == 'zendesk') {
            zendeskLogin(data);
        }
        else if (source == 'bfxd') {
            const token = params.get('token');
            if (token){
                bfxdLogin(data, token);
            }
        }
        else if (source == 'hub') {
            const state = params.get('state');
            if (state){
                hubLogin(data, state);
            }
        }
        else {
            if (data.email_verified) {
                doRedirect();
            }
        }
    }

    const doRedirect = () => {
        const params = new URLSearchParams(window.location.search);
        const returnUrl = params.get('redirect_url') || Cookies.get('redirect_url') || '/account/myaccount';
        Cookies.remove('redirect_url');
        window.location.href = returnUrl;
    }

    const discourseLogin = async (sso: string, sig: string, login: LoginData) => {
        grecaptcha.ready(async function () {
            const grecapToken = await grecaptcha.execute('6LeQ58wUAAAAAOO3JdYg_gxcIMwN9GXg8cWkz1i_', { action: 'discourse_login' })
            const payload: any = {
                sso: sso,
                sig: sig,
                'g-recaptcha-response': grecapToken
            }
            const params = Object.keys(payload).map(function(k) {
                return encodeURIComponent(k) + '=' + encodeURIComponent(payload[k])
            }).join('&');
            const {data : redirectUrl} = await axiosGet(
                baseURL + '/discourse_loginv3?' + params, 
                { auth: { username: login.email, password: login.token } }
            )
            window.location.href = redirectUrl;
        })
    }

    const zendeskLogin = async (login: LoginData) => {
        var payload = {
            email: login.email,
            token: login.token
        }
        try{
            const {data : zdJwt} = await axiosPost('/zendesk_login', payload);
            window.location.href = 'https://borisfx.zendesk.com/access/jwt?jwt=' + zdJwt;
        }
        catch(err){
            window.location.href='/account/myaccount';
        }
    }

    // Stores the browser session under the app's request token so the app can trade it for its own token.
    const initDesktopLogin = async (login: LoginData, requestToken: string) => {
        const payload = {
            requestToken: requestToken
        };
        const { data } = await axiosPost('/bfxd/login/init', payload, { auth: { username: login.email, password: login.token } })
        return data;
    }

    const bfxdLogin = async (login: LoginData, bfxdToken: string) => {
        try{
            await initDesktopLogin(login, bfxdToken);
            const url = '/account/bfxd-login-complete/?token=' + bfxdToken + '&email=' + encodeURIComponent(login.email);
            window.location.href = url;
        }
        catch(err){
            console.error(err);
        }
    }

    const hubLogin = async (login: LoginData, state: string) => {
        try{
            const init = await initDesktopLogin(login, crypto.randomUUID());
            completeHubLogin(init.request_token, state);
        }
        catch(err){
            console.error(err);
            errorToast(t('login.formErrors.hubUnavailable'), {containerId: toastContainerId});
        }
    }

    return (
        <div>
            <LoginToasts containerId={toastContainerId}>
                <LoginProvider>
                    <div className="login-page-container">
                        <div className="login-page-content box box-accent">
                            <LoginPanel onComplete={onLoginComplete} />
                        </div>
                    </div>
                </LoginProvider>
            </LoginToasts>
        </div>
    )
}
